import type { JSX } from 'react'

export type PlayHandoffProps = {
  roleName: string
  roleColor: string
  /** Сколько реплик роль отыграет подряд. */
  count: number
  onReady: () => void
}

function linesWord(count: number): string {
  const mod100 = count % 100
  const mod10 = count % 10
  if (mod100 >= 11 && mod100 <= 14) return 'реплик'
  if (mod10 === 1) return 'реплика'
  if (mod10 >= 2 && mod10 <= 4) return 'реплики'
  return 'реплик'
}

/**
 * Экран передачи устройства (docs/GAME.md, «Передача устройства»).
 * Без этой паузы второй игрок не успевает взять устройство и понять, что
 * от него хотят. Здесь же будущая точка расхождения на разные устройства:
 * в совместном режиме тут будет «ждём Селию».
 */
export function PlayHandoff({ roleName, roleColor, count, onReady }: PlayHandoffProps): JSX.Element {
  return (
    <div className="play-overlay">
      <div className="play-handoff">
        <div className="play-handoff-title">Передай устройство</div>
        <div className="play-handoff-role" style={{ color: roleColor }}>
          {roleName}
        </div>
        <div className="muted">
          Сейчас озвучивает эту роль — {count} {linesWord(count)} подряд
        </div>
        <button type="button" className="primary play-main" onClick={onReady}>
          Готов
        </button>
        <span className="faint">Enter или пробел</span>
      </div>
    </div>
  )
}
